module.exports = __webpack_public_path__ + "media/images/redesign-images/home-new/design-tile-images/design-tile-08-5c076b54f1a866b2f91700f2ac9c3bdf.png";